export default "__VITE_ASSET__DVmIb4BI__"